import { cva } from 'class-variance-authority';
import { FC } from 'react';
import customTwMerge from 'twMerge';

import ComparisonTableCell from 'components/Tables/Comparison/components/TableCell';
import { ComparisonTableRowField } from 'components/Tables/Comparison/config';

interface TableRowProps extends ComparisonTableRowField {
  isLastRow: boolean;
}

const cellStyles = cva('border-white/10 py-5 pl-8 pr-6 text-left text-md font-regular text-white', {
  variants: {
    isLastRow: {
      true: 'border-y',
      false: 'border-t',
    },
    isFirstCell: {
      true: 'border-l',
      false: 'border-r',
    },
  },
});

const TableRow: FC<TableRowProps> = ({ prismatic, competitor, rowHeading, isLastRow }) => (
  <tr className="[&:first-child_td:last-child]:rounded-tr-lg [&:first-child_th:first-child]:rounded-tl-lg [&:last-child_td:last-child]:rounded-br-lg [&:last-child_td]:border-b [&:last-child_th:first-child]:rounded-bl-lg">
    <th colSpan={2} scope="row" className={cellStyles({ isFirstCell: true, isLastRow })}>
      {rowHeading}
    </th>
    <td className="relative border-t border-white/10 px-6 py-5 text-center before:absolute before:-top-px before:left-0 before:h-[calc(100%_+_2px)] before:w-0.5 before:bg-primary-300 after:absolute after:-top-px after:right-0 after:h-[calc(100%_+_2px)] after:w-0.5 after:bg-primary-300">
      {prismatic && <ComparisonTableCell {...prismatic} />}
      {isLastRow && <div className="absolute -bottom-px left-0 h-0.5 w-full bg-primary-300" />}
    </td>

    <td className={customTwMerge(cellStyles({ isFirstCell: false, isLastRow }), 'px-6 py-5 text-center')}>
      {competitor && <ComparisonTableCell {...competitor} />}
    </td>
  </tr>
);

export default TableRow;
